import React from 'react';
import {useSelector} from "react-redux";
import {Link} from "react-router-dom";
import {rolesConstants, SchoolDropdownItem} from "mindsets-js-sdk";

import Curriculum from "./Curriculum";

export default function () {
    const me = useSelector(state => state.me);

    if (me && me.persona === rolesConstants.ROLE_TEACHER && me.school && process.env.FEATURE_SWITCH_NEW_PROFILE === true) {
        return (
            <div className="">
                <h4 className="header-new">My School Details</h4>

                <div className="user-info">
                    <div className="flex-column">
                        <div className="flex-row user-info-field">
                            <SchoolDropdownItem item={me.school}/>
                        </div>
                        <Curriculum/>
                    </div>

                    <div className="flex-row flex-wrap flex-box-5-10 mt-1">
                        <Link to='/profile/school' className="btn btn-dark">Change School</Link>
                    </div>
                </div>
            </div>
        );
    }

    return null;
}
